import React, { createContext, useContext, useState, useCallback } from "react";

interface BadgeRefreshContextType {
  refreshTrigger: number;
  triggerRefresh: () => void;
}

const BadgeRefreshContext = createContext<BadgeRefreshContextType | undefined>(
  undefined,
);

export const BadgeRefreshProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = useCallback(() => {
    setRefreshTrigger((prev) => prev + 1);
  }, []);

  return (
    <BadgeRefreshContext.Provider value={{ refreshTrigger, triggerRefresh }}>
      {children}
    </BadgeRefreshContext.Provider>
  );
};

export const useBadgeRefresh = () => {
  const context = useContext(BadgeRefreshContext);
  if (context === undefined) {
    throw new Error(
      "useBadgeRefresh must be used within a BadgeRefreshProvider",
    );
  }
  return context;
};
